import { Seo } from "../components/Seo";
import { LegalLayout } from "../components/LegalLayout";

const sections = [
  {
    title: "How to cancel",
    body: "You can cancel your engagement with Chatbudds at any time by emailing chatbudds2@gmail.com from your registered email address, or by sending a written request to our office. Unless your service agreement states otherwise, cancellation takes effect after a 30-day notice period, so we can wind down campaigns cleanly and hand everything over.",
  },
  {
    title: "What happens when you cancel",
    points: [
      "Active campaigns are paused at the end of the notice or billing period.",
      "Ad accounts, audiences, creatives and reports created during the engagement are handed over to you.",
      "Any assets you provided remain yours; final deliverables are transferred once all dues are cleared.",
    ],
    body: "When a cancellation is confirmed:",
  },
  {
    title: "Advertising spend",
    body: "In most cases your ad budget is billed to you directly by Meta and Google. In some cases, you may pay your advertising spend to us and we credit it to the platform on your behalf — any amount you have paid to us that has not yet been credited to the platform will be refunded to you in full. Amounts already credited to a platform are held and billed by that platform, so any unused balance or billing dispute there must be settled with the platform directly, and we cannot refund platform charges on their behalf.",
  },
  {
    title: "Refund eligibility",
    points: [
      "Setup or onboarding fees are non-refundable once work has begun.",
      "Unused full months of prepaid management fees are refunded in full.",
      "Partial months may be refunded pro-rata, at our discretion, based on work already completed.",
      "Approved refunds are processed to the original payment method within 7–10 business days.",
    ],
    body: "We keep refunds simple and fair:",
  },
  {
    title: "What is not refundable",
    points: [
      "Work already delivered, such as audits, strategy documents, creatives or copy.",
      "Charges levied by ad platforms (Meta, Google) or other third parties.",
      "Third-party tools or subscriptions purchased specifically for your account.",
    ],
    body: "The following cannot be refunded:",
  },
  {
    title: "How to request a refund",
    body: "Email chatbudds2@gmail.com with your name, the invoice number and the reason for your request. We review every request and respond within 2–3 business days.",
  },
  {
    title: "Contact us",
    body: "For anything about cancellations or refunds, reach us at chatbudds2@gmail.com, call or WhatsApp +91 84484 44896, or write to Chatbudds, 747, Niti Khand -1, Indirapuram, Ghaziabad.",
  },
];

export default function RefundPolicy() {
  return (
    <>
      <Seo
        title="Cancellation & Refund Policy — Chatbudds"
        description="How to cancel your Chatbudds engagement, what happens to your campaigns, and how refunds of management fees are handled."
      />
      <LegalLayout title="Cancellation & Refund Policy" updated="October 2026" sections={sections} testid="refund-page" />
    </>
  );
}
